import { useEffect } from "react";
import {
  AUTH_KEYS,
  SESSION_KEYS,
  getAppPrefix,
  getKnownUserIdKey,
  getLoginPath,
} from "../utils/authStorage";

let reloadTimer = null;

const scheduleSync = (action) => {
  if (reloadTimer) clearTimeout(reloadTimer);
  reloadTimer = setTimeout(action, 150);
};

const isCurrentAppKey = (storageKey) => {
  if (storageKey === null) {
    return false;
  }

  const prefix = getAppPrefix();
  if (!storageKey.startsWith(prefix)) {
    return false;
  }

  const baseKey = storageKey.slice(prefix.length);
  return AUTH_KEYS.includes(baseKey) || SESSION_KEYS.includes(baseKey);
};

export default function SessionSync() {
  useEffect(() => {
    sessionStorage.setItem(
      getKnownUserIdKey(),
      localStorage.getItem("_id") || ""
    );

    const handleStorage = (event) => {
      if (!isCurrentAppKey(event.key)) {
        return;
      }

      const newUserId = localStorage.getItem("_id");
      const knownUserId = sessionStorage.getItem(getKnownUserIdKey());

      if (!newUserId) {
        scheduleSync(() => {
          window.location.href = getLoginPath();
        });
        return;
      }

      if (knownUserId && newUserId !== knownUserId) {
        sessionStorage.setItem(getKnownUserIdKey(), newUserId);
        scheduleSync(() => {
          window.location.reload();
        });
        return;
      }

      if (
        event.key === authStorageKey("permissionArray") ||
        event.key === authStorageKey("Role") ||
        event.key === authStorageKey("authSessionId")
      ) {
        sessionStorage.setItem(getKnownUserIdKey(), newUserId);
        scheduleSync(() => {
          window.location.reload();
        });
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
      if (reloadTimer) clearTimeout(reloadTimer);
    };
  }, []);

  return null;
}

function authStorageKey(baseKey) {
  return `${getAppPrefix()}${baseKey}`;
}
